import React from "react";
import api from "@/lib/api";
import { PageHeader, ActionBar } from "@/components/PageBits";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";

function Card({ title, desc, file, params }) {
  const download = async () => {
    const r = await api.get(`/export/${file}`, { params, responseType: "blob" });
    const url = window.URL.createObjectURL(r.data);
    const a = document.createElement("a"); a.href = url; a.download = file; a.click();
  };
  return (
    <div className="bg-white border rounded-md p-5 flex flex-col" style={{ borderColor: "#E2E8F0" }}>
      <h3 className="font-bold">{title}</h3>
      <p className="text-sm text-slate-500 mt-1 flex-1">{desc}</p>
      <Button className="h-11 mt-4 bg-[#0A2540] hover:bg-[#113A63] text-white" onClick={download} data-testid={`export-${file}`}>
        <Download className="h-4 w-4 mr-2" /> CSV herunterladen
      </Button>
    </div>
  );
}

export default function ExportCenter() {
  return (
    <div data-testid="export-page">
      <PageHeader title="Exportcenter" subtitle="Alle Listen als CSV (Excel-kompatibel) exportieren" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card title="Aufträge" desc="Komplette Auftragsliste mit Status und Aufmaß-Summen" file="orders.csv" />
        <Card title="Mitarbeiterabrechnung" desc="Verdienst-Aufschlüsselung pro Mitarbeiter, gefiltert auf alle Aufträge" file="billing.csv" />
      </div>
      <ActionBar onPrint={() => window.print()} hideNext />
    </div>
  );
}
